// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__65tni","container":"style_container__LEwGu","links":"style_links__2uKyg","link":"style_link__090Gc"};